/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Assessment } from './Assessment';
import { AssessmentFromJSON, AssessmentFromJSONTyped, AssessmentToJSON } from './Assessment';

/**
 *
 * @export
 * @interface PaginatedAssessmentList
 */
export interface PaginatedAssessmentList {
  /**
   *
   * @type {number}
   * @memberof PaginatedAssessmentList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedAssessmentList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedAssessmentList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Assessment>}
   * @memberof PaginatedAssessmentList
   */
  results: Array<Assessment>;
}

/**
 * Check if a given object implements the PaginatedAssessmentList interface.
 */
export function instanceOfPaginatedAssessmentList(value: object): value is PaginatedAssessmentList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedAssessmentListFromJSON(json: any): PaginatedAssessmentList {
  return PaginatedAssessmentListFromJSONTyped(json, false);
}

export function PaginatedAssessmentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedAssessmentList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(AssessmentFromJSON),
  };
}

export function PaginatedAssessmentListToJSON(value?: PaginatedAssessmentList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(AssessmentToJSON),
  };
}
